import { AbstractControl } from '@angular/forms';

/**
 * Validator for password inputs
 */
export class PasswordValidators {
  static strong(control: AbstractControl): { [key: string]: any } | null {
    const error = { strongPassword: true };
    if (!control.value) {
      return error;
    }

    return new RegExp(/(?=.*\d)(?=.*\W)(?!.*\n)(?=.*[A-Z])(?=.*[a-z]).{8,}$/).test(control.value) ? null : error;
  }

  static passwordMatch = (control: AbstractControl) => (matchControl: AbstractControl) => {
    return matchControl.value === control?.value ? null : { passwordMatch: false };
  };
}
